import { DataEntry } from "../../shared/data-entry.interface";
import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { WebcallsService } from 'src/app/webcalls.service';
import { DataproviderService } from 'src/app/dataprovider.service';
import { TooltipTypesEnum } from 'src/app/shared/tooltip-types.enum';
import { ProgressiveBarService } from 'src/app/shared/progressive-bar/progressive-bar.service';

@Component({
  selector: 'app-finishing',
  templateUrl: './finishing.component.html',
  styleUrls: ['./finishing.component.scss','./finishing.component.responsive.scss','../lateral-series.scss'],
  host: {
    class: 'd-block bg-standard  p-b-104'
  }
})
export class FinishingComponent implements OnInit {

  title: string    = "b2c.IDS_FINISHING";
  subtitle: string = "b2c.IDS_FINISHING_SUB";
  showSubtitle: boolean = true;
  subtitleInfo: string = "b2c.IDS_FINISHING_GUIDE";
  showSubtitleInfo: boolean = true;
  question: string = "b2c.IDS_FINISHING_QUE";
  activePage: string = "finishing";
  nextPage: string = "coverconfigurator";
  eventCategory: string = "IDS_GTAG_CATEGORY";
  eventLabel: string = "IDS_FINISHING_LABEL_TECHNOLOGY_".concat(this.ds.getTechnologyID().toString());
  dataEntries:  DataEntry[]    = [];
  isWaitingPreload: boolean = false;
  tooltipType: TooltipTypesEnum = TooltipTypesEnum.DISCOVER;

  showSidebar: boolean = false;

  constructor(
    private cs: CommonService,
    private ws: WebcallsService,
    private ds: DataproviderService,
    private progressiveBarService: ProgressiveBarService
  ) {
    this.cs.setParams(
      this.title,
      this.subtitle,
      this.question,
      this.activePage,
      this.nextPage,
      false,
      true,
      false,
      true,
      null,
      false,
      true,
      this.eventCategory,
      null,
      false,
      null,
      true,
      this.showSubtitle,
      this.showSubtitleInfo,
      '',
      this.subtitleInfo
    );
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(7);
  }

  ngOnInit() {
    this.cs.setEventAction(undefined);
    if (this.ds.getPossibleFinishings().length > 0){
      this.setDataEntries(this.ds.getPossibleFinishings());
      this.preloadNextStep();
    } else{
      this.wsCall();
    }
  }

  setDataEntries(data: {}){
    if (Array.isArray(data)){
      data.forEach(fin => {
        let finEntry: DataEntry = {
          ID: fin["ID"],
          name: fin.Nome,
          name_ref: fin.Nome_ref,
          description: fin.Description,
          image: "../../assets/img/btns/finishing-" + fin.Nome_ref + ".png",
          tooltip: fin.ReportDescription,
          checked: false
        };
        this.dataEntries.push(finEntry);
      });
      const filteredFin = this.dataEntries.filter(fin => fin.ID !== 2);
      this.dataEntries = filteredFin;
      this.initSelection();
    }
  }

  wsCall(){
    this.ws.getFinishing(this.ds.getLocalizationID(), this.ds.getTechnologyID()/*, this.ds.getSelectedPlugs()*/).subscribe( data => {
      this.setDataEntries(data);
    });
    this.preloadNextStep();
  }

  preloadNextStep() {
    // pre-load configuratore
    if (this.ds.getCachedCoverConfiguratorData().length = 0){
      this.isWaitingPreload = true;
      this.ws.getCoverConfiguratorData(this.ds.getLocalizationID()).subscribe(data => {
        this.ds.setCachedCoverConfiguratorData(data);
        this.isWaitingPreload = false;
        if (this.ds.getFinishing()) {
          this.cs.updateNextBtn(true);
        }
      });
    } else {
      if (this.ds.getFinishing()) {
        this.cs.updateNextBtn(true);
      }
    }
  }

  initSelection() {
    let selectedData = this.ds.getFinishing();
    if (selectedData) {
      let finDataEntry = this.dataEntries.find(f => f.ID === selectedData.ID);
      if (finDataEntry) {
        this.dataEntriesUpdate(finDataEntry.ID);
        this.ds.setFinishing(finDataEntry);
        this.onFinishingSelected(finDataEntry.ID, false);
      } else {
        this.onFinishingSelected(null, true);
      }
    }
  }

  dataEntriesUpdate(idSelected: number){
    /* single selection */
    for (let data of this.dataEntries) {
      if ( data["ID"] == idSelected ) { data.checked = true; } else { data.checked = false; }
    }
    if (!this.isWaitingPreload) {
      this.cs.updateNextBtn(true);
    }
  }

  onSelectorClicked(idSelected: number){
    //this.onBeforeChangeFinishing();
    this.dataEntriesUpdate(idSelected);
    this.ds.setFinishing(this.dataEntries.find(function(fin){
      return fin["ID"] == idSelected;
    }));
    //this.onAfterChangeFinishing();
    this.onFinishingSelected(idSelected, true);

    let listChooise: [{ key: string; value: number; }];
    listChooise = this.cs.getOtherInfoFromSelector(this.dataEntries,idSelected,'STEP_3_');
    this.cs.setGASelectionEvent('step_3',listChooise);
  }

  onFinishingSelected(idSelected: number, clearShape: boolean) {
    if (clearShape) {
      this.ds.setShape(null);
    }
    if (idSelected) {
      if (idSelected == 3){
        this.nextPage = "frameshape";
      } else if ((this.ds.getTechnologyID() == 2) && (idSelected == 4)){
        this.nextPage = "coverconfigurator";
      } else if ((this.ds.getTechnologyID() == 3) && (idSelected == 7)) {
        this.ds.setDigitalCommands(true);
        this.nextPage = "packages";
      } else if ((this.ds.getTechnologyID() == 3) && (idSelected == 4)) {
        this.nextPage = "coverconfigurator";
      } else
        this.nextPage = "coverconfigurator";

      this.ds.setDigitalCommands((idSelected == 7) ? true : false);
    }
    this.cs.updateNextPage(this.nextPage);
    //this.ds.clearShapeAndSwitch();
  }

  onBeforeChangeFinishing() {
    console.log("Deprecated - finishing.component.onBeforeChangeFinishing");
    /* deprecated
    let oldFinishing = this.ds.getFinishing();
    if (oldFinishing && oldFinishing["ID"]) {
      this.as.onBeforeChangeFinishing(oldFinishing["ID"]);
    }
    */
  }

  onAfterChangeFinishing() {
    console.log("Deprecated - finishing.component.onAfterChangeFinishing");
    /* deprecated
    let finishing = this.ds.getFinishing();
    if (finishing && finishing["ID"]) {
      this.as.onChangeFinishing(finishing["ID"]);
    }
    */
  }

  onCloseTooltip() {
    this.showSidebar = false;
  }
}
